import React, { useEffect, useState } from 'react';
import {Drawer, Table} from 'antd';

import AddSetupDetails from 'modules/system_setup/add_system_setup_values/addSetupDetails';

const columns = [
    {
        title: "MODULE CODE",
        dataIndex: "module_code",
        key: "module_code",
        width: "10%"
    },
    {
        title: "MODULE NAME",
        dataIndex: "module_name",
        key: "module_name",
        width: "30%"
    },
    {
        title: "DESCTIPTION",
        dataIndex: "module_desc",
        key: "module_desc",
        width: "35%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchModuleAccessTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data])

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check payment method refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }
    
    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.setupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
            >
                <AddSetupDetails 
                    setupDet={props.setupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                />
            </Drawer>
        </div>
    )
}

export default SearchModuleAccessTable;